import { Component, effect, inject, OnInit, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "app/shared/components/confirmation-dialog/confirmation-dialog.component";
import { DialogsService } from "app/shared/services/dialogs/dialogs.service";
import { firstValueFrom } from "rxjs";
import { DocumentModel } from "../../models/document.model";
import mime from "mime";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DocumentFacadeService } from "../../services/store/document-facade.service";
import { SharedModule } from "../../../../shared/shared.module";

@Component({
  selector: "vl-file-dialog",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./file-dialog.component.html",
  styleUrls: ["./file-dialog.component.scss"],
})
export class FileDialogComponent implements OnInit {
  documentFacade = inject(DocumentFacadeService);
  dialogsService = inject(DialogsService);
  dialogRef = inject(MatDialogRef<FileDialogComponent>);
  sanitizer = inject(DomSanitizer);

  data = inject<{
    fileTypeId: string;
    readOnly: boolean;
    doc: DocumentModel;
  }>(MAT_DIALOG_DATA);

  contentType = signal<string>(null);
  metaData = this.documentFacade.getMetadata(this.data.fileTypeId);
  sanitizeUrl: SafeResourceUrl;
  file = this.documentFacade.getById(this.data.fileTypeId);

  constructor() {
    this.documentFacade.loadById(this.data.fileTypeId);
    effect(() => {});
    if (this.file()?.path) {
      this.contentType.set(mime.getType(this.file().path));
      this.sanitizeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.file().url,
      );
    }
  }

  ngOnInit(): void {}

  async onDelete() {
    const dialogRef = this.dialogsService.open(
      ConfirmationDialogComponent,
      "fit-content",
      "fit-content",
      {
        title: "Suppression",
        message:
          "Vous êtes sur le point de supprimer le document. Confirmez-vous ?",
      },
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      this.dialogRef.close("delete");
    }
  }
}
